export const iconFontAwesomeSecurityHouseFire = (
	<i className="fa-solid fa-house-fire"></i>
);
